export class HttpApiError extends Error {
    public errors: string[]

    constructor(errors: string[]) {
        super(errors.join(', '))
        this.name = 'HttpApiError'
        this.errors = errors
        Object.setPrototypeOf(this, HttpApiError.prototype)
    }
}
